import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface HelpDialogData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-question-dialog',
  templateUrl: './question-dialog.component.html',
  styleUrls: ['./question-dialog.component.scss']
})
export class QuestionDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: HelpDialogData,
              private dialogRef: MatDialogRef<QuestionDialogComponent>) {}

  @Output()
  confirm: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
  }

  confirmDialog(): void {
    this.confirm.emit();
    this.dialogRef.close();
  }

}
